class Checkbox extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      checkboxState: [false, false]
    };

    this.handleCheckboxUpdate = this.handleCheckboxUpdate.bind(this);
  }

  handleCheckboxUpdate(i) {
    let checkboxState = this.state.checkboxState;
    checkboxState[i] = !checkboxState[i];
    this.setState({checkboxState});
  }


  render () {
    return (
      <li className="section__item">
        <h3 className="section__item-title" id="checkbox">
          Checkbox
          <span className="section__item-docs">
            Documentation: <a href="docs/scss#elements-mixin-checkbox" target="_blank">SCSS</a>
          </span>
        </h3>
        <div className="section__demo">
         <Collapser>
            <div className="demo">
              <h4 className="demo__title">Simple checkbox</h4>
              <div className="demo__code">
                <CodeBlock lang="html">
                {`
<div className="checkbox-demo">
  <div>
    <input
      type="checkbox"
      name="example" id="checkbox-example-v"
      value="finish"
    />
    <label for="checkbox-example-v">
      Finish the Gooey demos
    </label>
  </div>
  <div>
    <input
      type="checkbox"
      name="example"
      id="checkbox-example-i"
      class="lipstick"
      value="publish"
    />
    <label for="checkbox-example-i">
      Publish the new version
    </label>
  </div>
</div>
                `}
                </CodeBlock>
                <CodeBlock lang="scss">
                {`
.checkbox-demo {
  input[type='checkbox'] {
    @include checkbox($pure-black);

    &.lipstick {
      @include checkbox($lipstick);
    }
  }
}
                `}
                </CodeBlock>
              </div>
              <div className="demo__output">
                <Output>
                  <div className="checkbox-demo">
                    <div>
                      <input
                        type="checkbox"
                        name="example" id="checkbox-example-v"
                        value="finish"
                        checked={this.state.checkboxState[0]}
                      />
                      <label
                        for="checkbox-example-v"
                        onClick={() => this.handleCheckboxUpdate(0)}
                      >
                        Finish the Gooey demos
                      </label>
                    </div>
                    <div>
                      <input
                        type="checkbox"
                        name="example"
                        id="checkbox-example-i"
                        className="lipstick"
                        checked={this.state.checkboxState[1]}
                        value="publish"
                      />
                      <label
                        for="checkbox-example-i"
                        onClick={() => this.handleCheckboxUpdate(1)}
                      >
                        Publish the new version
                      </label>
                    </div>
                  </div>
                </Output>
              </div>
            </div>
          </Collapser>
        </div>
      </li>
    );
  }
};
